import { useTranslation } from "../localization/hooks";
import { useAppSettings, useAppSettingsError, useAppSettingsInitialized } from "./hooks";
const useAppSettingsGate = () => {
    const settings = useAppSettings();
    const isInitialized = useAppSettingsInitialized();
    const error = useAppSettingsError();
    const { t } = useTranslation();
    const isAppSettingsReady = settings !== null;
    const errorMessage = isInitialized && !isAppSettingsReady && error ? t("common:toast.error.appSettings") : null;
    return { isAppSettingsReady, errorMessage };
};
export default useAppSettingsGate;
